import { render, staticRenderFns } from "./PageElectricPanel.vue?vue&type=template&id=06c96d5a&scoped=true&"
import script from "./PageElectricPanel.vue?vue&type=script&lang=js&"
export * from "./PageElectricPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c96d5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06c96d5a')) {
      api.createRecord('06c96d5a', component.options)
    } else {
      api.reload('06c96d5a', component.options)
    }
    module.hot.accept("./PageElectricPanel.vue?vue&type=template&id=06c96d5a&scoped=true&", function () {
      api.rerender('06c96d5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/eicproducts/electric-panel-grant/PageElectricPanel.vue"
export default component.exports